import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import AnyWhereUserReviewPopup from '../../../CustomHooks/AnyWhereUserReviewPopup';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import ImageGalleryThumbs from './ImageGallaryThumb';
import ImageGalleryItem from './ImageGalleryItem';
import RightNav from './RightNav';
import { ImageThumbnails } from './styled';
import {
  autoPlayVideo,
  clicked_card_in_pdp,
  getImages,
  ParamToAdd,
  thumbnailPosition,
  thumbnailPositionDesktop,
  UrlIncluded,
  videoExist,
  videoParent,
} from './utils';

const VideoReviewPopup = dynamic(
  () => import('../../ProductNew/VideoReviews/VideoReviewPopup'),
  { ssr: false },
);
const FullScreen = dynamic(() => import('./fullscreen'), { ssr: false });

export default function ImageGallaryCarousel(props) {
  const {
    product,
    user_review_images,
    userType,
    desktop,
    fromResult,
    isFertilityProduct,
    videoRef,
    showNewDiaperVariantUx,
  } = props;
  const count_images = user_review_images?.length;
  const Images = product?.images;
  const ImagesAltText = product?.images_alt_text;
  const VideoIndex = Images?.findIndex((item) => videoExist(item));
  // const [thumnNailPosition, setThumnNailPosition] =
  //     useState(thumbnailPosition);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [videoData, setvideoData] = useState('');
  const [gesture, setGesture] = useState(false);
  const selectedIndex = useRef(0);
  const setRenderFullScreen = useRef(() => {});
  const currentIndex = useRef(0);
  const galleryRef = useRef(null);
  const router = useRouter();
  const productImages = useRef(getImages(product, count_images, ImagesAltText));
  const productName = product?.name;
  const [showCarouselPopup, setShowCarouselPopup] = useState(false);

  const handleCarouselPopup = (url) => {
    if (url.includes(UrlIncluded)) setIsFullscreen(true);
    else setIsFullscreen(false);
  };
  useRouterChangeStart(handleCarouselPopup);

  // useEffect(() => {
  //     getDeviceType() === "desktop"
  //         ? setThumnNailPosition(thumbnailPositionDesktop)
  //         : setThumnNailPosition(thumbnailPosition);
  // }, []);

  useEffect(() => {
    productImages.current = getImages(product, count_images, ImagesAltText);
  }, [product?.id]);

  useEffect(() => {
    if (showPopup) document.body.classList.add('noScroll');
    else document.body.classList.remove('noScroll');
  }, [showPopup]);
  const total_count_images = productImages.current?.length;

  const onClickImage = (e, index) => {
    clicked_card_in_pdp(e, index, product, total_count_images, 'Image');
    setGesture(true);
    setTimeout(() => {
      let Url = Images[galleryRef?.current?.state.currentIndex];
      if (!videoExist(Url)) setRenderFullScreen.current();
      setGesture(false);
    }, 50);
  };

  const onslideImage = (index) => {
    currentIndex.current = index;
  };

  const fullscreenClickHandler = () => {
    const currentIndex = galleryRef?.current?.state.currentIndex;
    let Url = Images[currentIndex];
    if (videoExist(Url)) {
      if (currentIndex < VideoIndex) selectedIndex.current = currentIndex;
      else if (currentIndex > VideoIndex)
        selectedIndex.current = currentIndex - 1;
    } else selectedIndex.current = currentIndex;
    setIsFullscreen(true);
    const params = new URLSearchParams(window.location.search);
    params.set(UrlIncluded, 'true');
    router.push(`${window.location.pathname}/?${params}`, undefined, {
      shallow: true,
      scroll: false,
    });
  };
  return (
    <>
      <ImageThumbnails
      // className={
      //     pdpDotsExperiment(userType) || desktop
      //         ? ""
      //         : "dotsThumbnail"
      // }
      >
        <ImageGallery
          items={productImages?.current}
          renderItem={(item) => {
            return (
              <ImageGalleryItem
                item={item}
                gesture={gesture}
                setGesture={setGesture}
                setShowPopup={setShowPopup}
                setvideoData={setvideoData}
                product={product}
                productName={productName}
                user_review_images={user_review_images}
                setShowCarouselPopup={setShowCarouselPopup}
                total_count_images={total_count_images}
                parent={'Image'}
                isFertilityProduct={isFertilityProduct}
                videoRef={videoRef}
                userType={userType}
                showNewDiaperVariantUx={showNewDiaperVariantUx}
              />
            );
          }}
          renderThumbInner={(item) => {
            // return pdpDotsExperiment(userType) || desktop ? (
            return (
              <ImageGalleryThumbs
                item={item}
                productName={productName}
                user_review_images={user_review_images}
                total_count_images={total_count_images}
                parent={'thumbnail'}
                product={product}
              />
            );
            // ) : (
            //     <CarouselDots
            //         selected={
            //             galleryRef?.current?.state.currentIndex
            //         }
            //         item={item}
            //     />
            // );
          }}
          thumbnailPosition={
            desktop ? thumbnailPositionDesktop : thumbnailPosition
          }
          ref={galleryRef}
          showPlayButton={false}
          onThumbnailClick={(event, index, ...args) => {
            const isImageReview =
              productImages.current[index].type === 'custom';
            clicked_card_in_pdp(
              event,
              index,
              product,
              productImages.current?.length,
              'thumbnail',
              isImageReview,
            );
          }}
          onClick={!fromResult ? onClickImage : null}
          onSlide={onslideImage}
          renderFullscreenButton={() => (
            <FullScreen
              clickHandler={fullscreenClickHandler}
              isFullscreen={isFullscreen}
              setRenderFullScreen={setRenderFullScreen}
              product={Images}
              selectedImageIndex={selectedIndex.current}
              user_review_images={user_review_images}
              desktop={desktop}
            />
          )}
          renderRightNav={(onClick, disabled) => {
            return (
              <RightNav
                right={true}
                onClick={onClick}
                disabled={disabled}
                currentIndex={galleryRef?.current?.state.currentIndex}
                product={product}
                imgLength={productImages?.current?.length}
                isImageReview={
                  productImages?.current[
                    galleryRef?.current?.state.currentIndex
                  ]?.type === 'custom'
                }
              />
            );
          }}
          renderLeftNav={(onClick, disabled) => {
            if (galleryRef?.current?.state.currentIndex != 0)
              return (
                <RightNav
                  onClick={onClick}
                  disabled={disabled}
                  currentIndex={galleryRef?.current?.state.currentIndex}
                  product={product}
                  imgLength={productImages?.current?.length}
                  isImageReview={
                    productImages?.current[
                      galleryRef?.current?.state.currentIndex
                    ]?.type === 'custom'
                  }
                />
              );
          }}
          showNav={true}
        />
      </ImageThumbnails>
      <VideoReviewPopup
        videoData={videoData}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        paramsAdd={ParamToAdd}
        autoPlay={autoPlayVideo}
        product={product}
        videoUrl={videoData}
        parent={videoParent}
      />
      <AnyWhereUserReviewPopup
        imagesByUser={user_review_images}
        selectedIndex={0}
        showCarouselPopup={showCarouselPopup}
        setShowCarouselPopup={setShowCarouselPopup}
        productId={product?.id}
      />{' '}
    </>
  );
}
